module.exports = __webpack_public_path__ + "static/media/3.f03f9e6c.jpg";